/*
  Add here your own custom javascript codes
*/

/*
  "Įdėta į krepšelį" pranešimas (toast)

  Vietoje peradresavimo į /cart puslapį (nustatymas "Redirect to cart page after
  add" yra išjungtas) parodomas animuotas pranešimas su ką tik pridėta preke.

  Klausomasi įvykių, kuriuos siunčia assets/cart.js:
  - kt.cart.added    -> prekė sėkmingai pridėta
  - kt.cart.error    -> Shopify grąžino klaidą (pvz., nebeliko sandėlyje)
  - kt.cart.reloaded -> krepšelio elementai perpiešti (animuojame ikonos skaičių)
*/
(function () {
  const DURATION = 5000 // kiek ms pranešimas laikomas ekrane
  const ERROR_DURATION = 7000 // klaidos pranešimui duodame daugiau laiko
  const MAX_ITEMS = 3 // kiek prekių daugiausia rodoma sąraše

  const t = (key, fallback) => window.theme?.locales?.cart?.[key] || fallback

  // Daugiskaitos forma pagal puslapio kalbą (lt: 1 prekė / 2 prekės / 11 prekių)
  const pluralize = (count) => {
    let form = count === 1 ? 'one' : 'other'

    try {
      form = new Intl.PluralRules(document.documentElement.lang || 'lt').select(count)
    } catch (err) { /* naršyklė nepalaiko Intl.PluralRules */ }

    const template =
      t(`more_items_${form}`) ||
      t('more_items_other', 'dar %count% prekių')

    return template.replace('%count%', count)
  }

  let toast = null
  let hideTimeout = null
  let pendingAdd = false
  let duration = DURATION

  /* ---------- Pagalbinės funkcijos ---------- */

  const formatMoney = (cents) => {
    const format = window.Shopify?.moneyFormat || '{{ amount }}'
    const placeholder = /\{\{\s*(\w+)\s*\}\}/

    const withDelimiters = (precision, thousands, decimal) => {
      const number = (Number(cents) / 100).toFixed(precision)
      const parts = number.split('.')
      const units = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
      return units + (parts[1] ? decimal + parts[1] : '')
    }

    if (isNaN(Number(cents))) return ''

    let value
    switch (format.match(placeholder)?.[1]) {
      case 'amount_no_decimals': value = withDelimiters(0, ',', '.'); break
      case 'amount_with_comma_separator': value = withDelimiters(2, '.', ','); break
      case 'amount_with_apostrophe_separator': value = withDelimiters(2, "'", '.'); break
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(0, '.', ','); break
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(0, ' ', ','); break
      case 'amount_with_space_separator': value = withDelimiters(2, ' ', ','); break
      default: value = withDelimiters(2, ',', '.')
    }

    // moneyFormat gali turėti HTML (pvz. <span class="money">) - jį pašaliname
    return format.replace(placeholder, value).replace(/<[^>]*>/g, '').trim()
  }

  const resizeImage = (url, width) => {
    if (!url) return null
    try {
      const parsed = new URL(url, window.location.origin)
      if (!/^https?:$/.test(parsed.protocol)) return url
      parsed.searchParams.set('width', width)
      return parsed.href
    } catch (err) {
      return url
    }
  }

  const svgCheck = `
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle class="ks-atc-toast-check-circle" cx="16" cy="16" r="14"></circle>
      <path class="ks-atc-toast-check-path" d="M9.5 16.5 L14 21 L22.5 12"></path>
      <path class="ks-atc-toast-alert-path" d="M16 8.5 L16 17"></path>
      <path class="ks-atc-toast-alert-path" d="M16 22.5 L16 22.5"></path>
    </svg>`

  const svgClose = `
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="1.75" stroke-linecap="round" aria-hidden="true">
      <path d="M18 6 6 18M6 6l12 12"></path>
    </svg>`

  /* ---------- Pranešimo kūrimas ---------- */

  const buildToast = () => {
    const elem = document.createElement('div')
    elem.className = 'ks-atc-toast'
    elem.setAttribute('role', 'status')
    elem.setAttribute('aria-live', 'polite')
    elem.setAttribute('aria-atomic', 'true')

    elem.innerHTML = `
      <div class="ks-atc-toast-inner">
        <div class="ks-atc-toast-header">
          <span class="ks-atc-toast-check">${svgCheck}</span>
          <p class="ks-atc-toast-title"></p>
          <button class="ks-atc-toast-close" type="button"
            aria-label="${t('close', 'Uždaryti')}">${svgClose}</button>
        </div>
        <div class="ks-atc-toast-items"></div>
        <div class="ks-atc-toast-actions">
          <a class="btn btn-primary btn-sm" href="${window.Shopify?.routes?.cart_url || '/cart'}"></a>
          <button class="btn btn-outline-secondary btn-sm" type="button" data-dismiss></button>
        </div>
        <div class="ks-atc-toast-progress"><span></span></div>
      </div>`

    elem.querySelector('.ks-atc-toast-close').addEventListener('click', hide)
    elem.querySelector('[data-dismiss]').addEventListener('click', hide)

    // Laikmatis stabdomas, kol pelė ar fokusas yra ant pranešimo
    elem.addEventListener('mouseenter', pause)
    elem.addEventListener('focusin', pause)
    elem.addEventListener('mouseleave', resume)
    elem.addEventListener('focusout', resume)

    document.body.appendChild(elem)
    return elem
  }

  const renderItems = (items) => {
    const wrapper = toast.querySelector('.ks-atc-toast-items')
    wrapper.innerHTML = ''

    items.slice(0, MAX_ITEMS).forEach((item, index) => {
      const image = resizeImage(item.image || item.featured_image?.url, 160)
      const title = item.product_title || item.title || ''
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? item.variant_title
        : ''
      const qty = Number(item.quantity) || 1
      const price = item.final_line_price ?? (item.final_price ?? item.price) * qty

      const meta = [variant, `${qty} ${t('unit', 'vnt.')}`].filter(Boolean).join(' · ')

      const row = document.createElement('div')
      row.className = 'ks-atc-toast-item'
      row.style.setProperty('--ks-item-index', index)
      row.innerHTML = `
        <div class="ks-atc-toast-img">
          ${image ? `<img src="${image}" alt="" width="56" height="56" loading="lazy">` : ''}
        </div>
        <div class="ks-atc-toast-info">
          <p class="ks-atc-toast-item-title"></p>
          <p class="ks-atc-toast-item-meta"></p>
        </div>
        <div class="ks-atc-toast-item-price"></div>`

      row.querySelector('.ks-atc-toast-item-title').textContent = title
      row.querySelector('.ks-atc-toast-item-meta').textContent = meta
      row.querySelector('.ks-atc-toast-item-price').textContent = formatMoney(price)

      wrapper.appendChild(row)
    })

    if (items.length > MAX_ITEMS) {
      const more = document.createElement('p')
      more.className = 'ks-atc-toast-more'
      more.textContent = `+ ${pluralize(items.length - MAX_ITEMS)}`
      wrapper.appendChild(more)
    }
  }

  /* ---------- Rodymas / slėpimas ---------- */

  const show = ({ items = [], title, isError = false }) => {
    toast = toast || buildToast()
    duration = isError ? ERROR_DURATION : DURATION

    // Paleidžiame animacijas iš naujo, jei pranešimas jau matomas
    toast.classList.remove('is-visible', 'is-paused')
    void toast.offsetWidth

    toast.style.setProperty('--ks-toast-duration', `${duration}ms`)

    // Mobiliajame prekės puslapyje apačioje gali būti lipnus "Į krepšelį" blokas
    const stickyAtc = document.querySelector('.sticky-atc.show')
    toast.style.setProperty('--ks-toast-offset', stickyAtc ? `${stickyAtc.offsetHeight}px` : '0px')

    toast.classList.toggle('ks-atc-toast-error', isError)
    toast.querySelector('.ks-atc-toast-title').textContent = title
    toast.querySelector('.ks-atc-toast-actions .btn-primary').textContent =
      t('view_cart', 'Peržiūrėti krepšelį')
    toast.querySelector('[data-dismiss]').textContent =
      t('continue_shopping', 'Tęsti apsipirkimą')

    renderItems(items)
    toast.querySelector('.ks-atc-toast-items').hidden = items.length === 0

    requestAnimationFrame(() => toast.classList.add('is-visible'))

    clearTimeout(hideTimeout)
    hideTimeout = setTimeout(hide, duration)
  }

  const hide = () => {
    clearTimeout(hideTimeout)
    toast?.classList.remove('is-visible', 'is-paused')
  }

  const pause = () => {
    clearTimeout(hideTimeout)
    toast?.classList.add('is-paused')
  }

  const resume = () => {
    if (!toast?.classList.contains('is-visible')) return
    toast.classList.remove('is-paused')
    clearTimeout(hideTimeout)
    hideTimeout = setTimeout(hide, duration)
  }

  /* ---------- Įvykiai ---------- */

  window.addEventListener('kt.cart.added', (event) => {
    // Krepšelio stalčiaus režimu atsidaro offcanvas - pranešimo nereikia
    if (window.theme?.cartType === 'drawer') return
    // Krepšelio puslapyje prekių sąrašas ir taip persipiešia
    if (document.querySelector('#main-cart')) return

    const data = event.detail

    // cart.js "changeVariant" atveju atsiunčiamas visas krepšelio objektas -
    // jį atpažįstame pagal "item_count" ir praleidžiame
    if (!data || data.item_count !== undefined) return

    const items = Array.isArray(data.items) ? data.items : [data]
    if (!items.length) return

    pendingAdd = true
    show({ items, title: t('added_title', 'Įdėta į krepšelį') })
  })

  window.addEventListener('kt.cart.error', (event) => {
    if (window.theme?.cartType === 'drawer') return
    if (document.querySelector('#main-cart')) return

    show({
      items: [],
      title: event.detail || t('add_error', 'Nepavyko įdėti į krepšelį'),
      isError: true
    })
  })

  // Krepšelio ikonos skaičius atnaujinamas po pridėjimo - jį "pašokdiname"
  window.addEventListener('kt.cart.reloaded', () => {
    if (!pendingAdd) return
    pendingAdd = false

    document.querySelectorAll('.cart-count-badge').forEach(badge => {
      badge.classList.remove('ks-badge-pop')
      void badge.offsetWidth
      badge.classList.add('ks-badge-pop')
    })
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') hide()
  })
})()
